import type {InletDescriptor, OutletDescriptor} from "#template/runtime-graph/descriptors"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {IMaterialData, MaterialGraph} from "@cm/material-nodes"

const TD = TypeDescriptors

const getMaterialDataDescriptor: {
    materialGraph: InletDescriptor<MaterialGraph>
    side: InletDescriptor<"front" | "back" | "double">
    realtimeSettings: InletDescriptor<IMaterialData["realtimeSettings"]>
    output: OutletDescriptor<IMaterialData>
} = {
    materialGraph: TD.inlet(TD.MaterialGraph),
    side: TD.inlet(TD.Identity<"front" | "back" | "double">()),
    realtimeSettings: TD.inlet(TD.Identity<IMaterialData["realtimeSettings"]>()),
    output: TD.outlet(TD.Identity<IMaterialData>()),
}

export class GetMaterialData implements NodeClassImpl<typeof getMaterialDataDescriptor, typeof GetMaterialData> {
    static descriptor = getMaterialDataDescriptor
    static uniqueName = "GetMaterialData"
    materialGraph!: Inlet<MaterialGraph>
    side!: Inlet<"front" | "back" | "double">
    realtimeSettings!: Inlet<IMaterialData["realtimeSettings"]>
    output!: Outlet<IMaterialData>

    run() {
        if (this.materialGraph === NotReady || this.side === NotReady || this.realtimeSettings === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }
        this.output.emitIfChanged({
            name: this.materialGraph.parameters.name ?? `Material ${this.materialGraph.uniqueId}`,
            materialGraph: this.materialGraph,
            side: this.side,
            realtimeSettings: this.realtimeSettings,
        })
    }
}
